import { render } from "./UserIncidents.vue?vue&type=template&id=7c877e1e&scoped=true"
import script from "./UserIncidents.vue?vue&type=script&lang=js"
export * from "./UserIncidents.vue?vue&type=script&lang=js"

import "./UserIncidents.vue?vue&type=style&index=0&id=7c877e1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c877e1e"]])

export default __exports__